export default __webpack_public_path__ + "static/media/5.483c62b2.svg";